import React from 'react';
import './WhyUs.css';

const reasons = [
  {
    img: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600&q=80',
    svg: (
      <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="56" height="56" rx="14" fill="#FFF0F0"/>
        <rect x="14" y="18" width="20" height="24" rx="3" stroke="#D01B1B" strokeWidth="1.8"/>
        <path d="M20 26 L23 29 L30 22" stroke="#D01B1B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="28" y="24" width="14" height="10" rx="2" stroke="#D01B1B" strokeWidth="1.5" opacity="0.5"/>
        <path d="M30 27 L38 27 M30 30 L36 30" stroke="#D01B1B" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
      </svg>
    ),
    title: 'In-House Software Development',
    desc: 'Our proprietary platform is built entirely in-house — full flexibility, no third-party dependency, and rapid custom development.',
  },
  {
    img: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&q=80',
    svg: (
      <svg viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#FFF0F0"/>
        <circle cx="28" cy="28" r="11" stroke="#D01B1B" strokeWidth="1.8"/>
        <path d="M28 20 L28 28 L34 31" stroke="#D01B1B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="28" cy="28" r="2" fill="#D01B1B"/>
        <path d="M22 14 L20 10 M34 14 L36 10" stroke="#D01B1B" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
      </svg>
    ),
    title: '24/7 Customer Support',
    desc: 'Our dedicated support team is available around the clock. Day, night, weekday, or weekend — we never sleep.',
  },
  {
    img: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&q=80',
    svg: (
      <svg viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#FFF0F0"/>
        <circle cx="28" cy="28" r="8" stroke="#D01B1B" strokeWidth="1.8"/>
        <circle cx="28" cy="28" r="13" stroke="#D01B1B" strokeWidth="1.2" strokeDasharray="4 3" opacity="0.5"/>
        <circle cx="28" cy="28" r="3" fill="#D01B1B"/>
        <path d="M28 15 L28 13 M28 43 L28 41 M15 28 L13 28 M43 28 L41 28" stroke="#D01B1B" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
      </svg>
    ),
    title: '24/7 Vigilance & Monitoring',
    desc: 'Our control room operates round-the-clock. Expert analysts monitor your fleet in real-time and proactively alert you.',
  },
  {
    img: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80',
    svg: (
      <svg viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#FFF0F0"/>
        <path d="M16 28 C16 22, 21 16, 28 16 S40 22, 40 28" stroke="#D01B1B" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M20 34 C20 30, 23 26, 28 26 S36 30, 36 34" stroke="#D01B1B" strokeWidth="1.5" strokeLinecap="round" opacity="0.6"/>
        <circle cx="28" cy="38" r="4" fill="#D01B1B" opacity="0.2"/>
        <circle cx="28" cy="38" r="2.5" fill="#D01B1B"/>
      </svg>
    ),
    title: 'Customized Solutions',
    desc: "We tailor every solution to your industry, fleet size, and operational requirements — no cookie-cutter packages.",
  },
  {
    img: 'https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=600&q=80',
    svg: (
      <svg viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#FFF0F0"/>
        <rect x="12" y="22" width="16" height="10" rx="2" stroke="#D01B1B" strokeWidth="1.8"/>
        <circle cx="15" cy="34" r="3" stroke="#D01B1B" strokeWidth="1.5"/>
        <circle cx="25" cy="34" r="3" stroke="#D01B1B" strokeWidth="1.5"/>
        <path d="M28 26 L33 22 L44 22 L44 32 L33 32 L28 32" stroke="#D01B1B" strokeWidth="1.8" strokeLinejoin="round"/>
        <circle cx="35" cy="34" r="3" stroke="#D01B1B" strokeWidth="1.5"/>
        <path d="M12 18 L44 18" stroke="#D01B1B" strokeWidth="1.2" strokeDasharray="3 2" opacity="0.35"/>
      </svg>
    ),
    title: 'Fleet Management Solutions',
    desc: 'A complete platform: live tracking, maintenance scheduling, fuel analytics, driver scoring, and executive reports — in one place.',
  },
  {
    img: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80',
    svg: (
      <svg viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#FFF0F0"/>
        <circle cx="24" cy="22" r="7" stroke="#D01B1B" strokeWidth="1.8"/>
        <path d="M14 42 C14 36, 18 32, 24 32 S34 36, 34 42" stroke="#D01B1B" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M36 26 L38 28 L43 23" stroke="#D01B1B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="38" cy="26" r="6" stroke="#D01B1B" strokeWidth="1.5" opacity="0.4"/>
      </svg>
    ),
    title: 'Customer-Obsessed Team',
    desc: 'Every team member is trained to put your success first. Deep expertise, genuine commitment, and high-performance delivery.',
  },
];

const WhyUs = () => (
  <section className="whyus-section section" id="why-us">
    <div className="container">
      <div className="whyus-inner">

        {/* Left sticky panel — unchanged */}
        <div className="whyus-left reveal-left">
          <span className="section-label">Why Choose Us</span>
          <h2>Built on Trust,<br />Powered by<br /><em>Technology</em></h2>
          <div className="divider" style={{ margin: '20px 0 24px' }} />
          <p className="whyus-desc">
            Since 2019, Dynamic Tracking Solutions has been Pakistan's most trusted fleet management partner. We combine deep industry expertise with cutting-edge technology to deliver results that matter.
          </p>

          <div className="whyus-milestones">
            <div className="wm-item">
              <div className="wm-val">2019</div>
              <div className="wm-lbl">Founded, Karachi</div>
            </div>
            <div className="wm-sep" />
            <div className="wm-item">
              <div className="wm-val">6000+</div>
              <div className="wm-lbl">Happy Clients</div>
            </div>
            <div className="wm-sep" />
            <div className="wm-item">
              <div className="wm-val">1st</div>
              <div className="wm-lbl">Global Partner</div>
            </div>
          </div>

          <a href="/contact-us" className="btn btn-primary">
            Talk to an Expert
            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
            </svg>
          </a>
        </div>

        {/* Right grid */}
        <div className="whyus-grid">
          {reasons.map((r, i) => (
            <div key={i} className="reason-card reveal" style={{ transitionDelay: `${i * 70}ms` }}>
              {/* Image on top */}
              <div className="rc-img">
                <img src={r.img} alt={r.title} loading="lazy" />
              </div>
              {/* SVG icon + text below */}
              <div className="rc-body">
                <div className="rc-svg">{r.svg}</div>
                <div className="rc-text">
                  <h3 className="rc-title">{r.title}</h3>
                  <p className="rc-desc">{r.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  </section>
);

export default WhyUs;